import Component from 'components/pages/Dashboard/Dashboard';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('dashboard');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Dashboard',
    description:
      'Taking online surveys for money is easy with LifePoints. Earn rewards from your favorite retailers and brands from home. Read more and sign up today.',
  },
});
